export default __webpack_public_path__ + "static/1094-6b5f67b764a3ac09b6a24cd392492995.gif";